import type { ReactNode } from "react";
import { ArrowLeft } from "lucide-react";
import { Link } from "react-router-dom";
import type { Role } from "@/types";

// Cabeçalho padrão das telas internas do admin: voltar para o hub + título.
export function AdminHeader({
  title,
  caption,
  action,
}: {
  title: string;
  caption?: string;
  action?: ReactNode;
}) {
  return (
    <div className="flex items-center gap-3">
      <Link
        to="/admin"
        aria-label="Voltar para o Admin"
        className="flex h-9 w-9 shrink-0 items-center justify-center rounded-full border border-border bg-card text-muted-foreground transition-colors hover:text-foreground"
      >
        <ArrowLeft size={18} />
      </Link>
      <div className="min-w-0 flex-1">
        <h1 className="truncate text-xl font-bold">{title}</h1>
        {caption && (
          <p className="truncate text-xs text-muted-foreground">{caption}</p>
        )}
      </div>
      {action}
    </div>
  );
}

export const ROLE_LABEL: Record<Role, string> = {
  super_admin: "Super Admin",
  admin: "Admin",
  collaborator: "Colaborador",
  user: "Jogador",
};

// Regras de papel vivem em @/lib/permissions (única fonte no web);
// re-exportadas aqui por conveniência das telas admin.
export {
  canAdjustBalance,
  canAssignRole,
  canManageUsers,
} from "@/lib/permissions";

/** Mensagem de erro padrão para catch de chamadas admin. */
export function errMessage(err: unknown): string {
  return err instanceof Error ? err.message : "Erro inesperado. Tente novamente.";
}
